/**
 * Asset Name Cell Renderer
 *
 * Shows appropriate icon for seed-sourced assets.
 */

import { Seeds as SeedsIcon } from '@praetorian-chariot/ui';
import React from 'react';

import { NameColumn } from '@/components/NameColumn';
import type { Asset } from '@/types';
import { getDisplayIdentifierWithFallback } from '@/utils/displayIdentifier.util';

interface AssetNameCellProps {
  asset: Asset;
}

/**
 * Memoized cell renderer for asset name column to improve performance
 *
 * Field priority is clearly documented in getDisplayIdentifierWithFallback function.
 *
 * @param asset - The asset to render
 * @returns NameColumn component with appropriate identifier and icon
 */
export const AssetNameCell: React.FC<AssetNameCellProps> = React.memo(
  ({ asset }) => {
    const displayName = getDisplayIdentifierWithFallback(asset, '');

    const icon =
      asset.source === 'seed' ? <SeedsIcon className="size-4" /> : undefined;

    return (
      <NameColumn name={displayName} description={asset.group} icon={icon} />
    );
  }
);

AssetNameCell.displayName = 'AssetNameCell';
